export const JWT_CONSTANTS = Object.freeze({
  TOKEN: "token",
  JWT_TOKEN_TYPE: "",
  SESSION_EXPIRATION_TIME: "sessionExpirationTime",
  LAST_ACTIVITY_TIME: "lastActivityTime",
  PROFILE: "profile",
});
